import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { FC, MouseEvent, useCallback } from 'react';

interface ErrorTooltipFooterProps {
  onDismiss(): void;
  onViewDetails?(): void;
  shouldShowDetails?: boolean;
}

export const ErrorTooltipFooter: FC<ErrorTooltipFooterProps> = ({
  onDismiss,
  onViewDetails,
  shouldShowDetails = false,
}) => {
  const onViewDetailsButtonClicked = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      if (onViewDetails) {
        onViewDetails();
      }
    },
    [onViewDetails],
  );
  const onDismissButtonClicked = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onDismiss();
    },
    [onDismiss],
  );

  return (
    <div data-e2e="tooltip-footer" className="p-2">
      {shouldShowDetails && (
        <button
          className="btn btn-sm btn-default w-100"
          type="button"
          data-e2e="tooltip-view-details-button"
          onClick={onViewDetailsButtonClicked}
        >
          <FormattedMessage id="viewDetails" />
        </button>
      )}
      <button
        className="btn btn-sm btn-flat-secondary w-100 mt-1"
        type="button"
        data-e2e="tooltip-dismiss-button"
        onClick={onDismissButtonClicked}
      >
        <FormattedMessage id="dismiss" />
      </button>
    </div>
  );
};
